export default __webpack_public_path__ + "static/media/elementalwrack.badd1009.png";